<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h2 class="text-white">AQAR 2020 - 2021</h2>
          <ul class="breadcrumb">
            <li>
              <a routerLink="/">Home</a>
            </li>/
            <li class="active">
              <a routerLink="/aqar">AQAR 2020 - 2021</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="online-anti-ragging ptb--100  verticaltab--1">
  <div class="container">
    <div class="row">
      <div class="col">
        <div class="row align-items-start hustify-content-center">
          <div class="nav flex-column nav-pills col-3" id="v-pills-tab" role="tablist" aria-orientation="vertical">
            <button class="nav-link active" id="v-pills-criteria1-tab" data-bs-toggle="pill"
              data-bs-target="#v-pills-criteria1" type="button" role="tab" aria-controls="v-pills-criteria1"
              aria-selected="true">Criteria-1</button>
            <button class="nav-link" id="v-pills-Criteria2-tab" data-bs-toggle="pill"
              data-bs-target="#v-pills-Criteria2" type="button" role="tab" aria-controls="v-pills-Criteria2"
              aria-selected="false">Criteria-2</button>
            <button class="nav-link" id="v-pills-Criteria3-tab" data-bs-toggle="pill"
              data-bs-target="#v-pills-Criteria3" type="button" role="tab" aria-controls="v-pills-Criteria3"
              aria-selected="false">Criteria-3</button>
            <button class="nav-link" id="v-pills-Criteria4-tab" data-bs-toggle="pill"
              data-bs-target="#v-pills-Criteria4" type="button" role="tab" aria-controls="v-pills-Criteria4"
              aria-selected="false">Criteria-4</button>
            <button class="nav-link" id="v-pills-Criteria5-tab" data-bs-toggle="pill"
              data-bs-target="#v-pills-Criteria5" type="button" role="tab" aria-controls="v-pills-Criteria5"
              aria-selected="false">Criteria-5</button>
            <button class="nav-link" id="v-pills-Criteria6-tab" data-bs-toggle="pill"
              data-bs-target="#v-pills-Criteria6" type="button" role="tab" aria-controls="v-pills-Criteria6"
              aria-selected="false">Criteria-6</button>
            <button class="nav-link" id="v-pills-Criteria7-tab" data-bs-toggle="pill"
              data-bs-target="#v-pills-Criteria7" type="button" role="tab" aria-controls="v-pills-Criteria7"
              aria-selected="false">Criteria-7</button>
            <button class="nav-link" id="v-pills-template-tab" data-bs-toggle="pill" data-bs-target="#v-pills-template"
              type="button" role="tab" aria-controls="v-pills-template" aria-selected="false">Extended Template</button>
          </div>
          <div class="tab-content col-9" id="v-pills-tabContent">
            <!-- criteria 1 -->
            <div class="tab-pane fade show active" id="v-pills-criteria1" role="tabpanel"
              aria-labelledby="v-pills-criteria1-tab">
              <h3 class="yellow-color">Criteria 1</h3>
              <div class="row row-cols-2 justify-content-start align-items-top mt-3">
                <div class="accordion accordian-class table--1" id="criteria1">
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria1-1" data-bs-toggle="collapse"
                      data-bs-target="#criteria1-1-1" aria-expanded="true" aria-controls="criteria1-2-1">
                      1.1
                    </h2>
                    <div id="criteria1-1-1" class="accordion-collapse collapse show" aria-labelledby="criteria1-1"
                      data-bs-parent="#criteria1">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li>
                            <a href="https://drive.google.com/file/d/1b2cu8nUFA2xT-i0PeuSnydyr7ddKTnt7/view"
                              target="_blank">1.1.1</a>
                          </li>
                          <li>
                            <a href="https://drive.google.com/file/d/1mI6j6h69zLCAfFXJVl3QrBAsreqHb5zg/view"
                              target="_blank">1.1.2</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria1-3" data-bs-toggle="collapse"
                      data-bs-target="#criteria1-3-2" aria-expanded="true" aria-controls="collapseOne">
                      1.3
                    </h2>
                    <div id="criteria1-3-2" class="accordion-collapse collapse" aria-labelledby="criteria1-3"
                      data-bs-parent="#criteria1">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li>
                            <a href="https://drive.google.com/file/d/1hq5xCk8DLAIJFVHhCmiLHLhh-z0jq0G6/view"
                              target="_blank">1.3.1</a>
                          </li>
                          <li>
                            <a href="https://drive.google.com/file/d/1IOFFUa1CNI1GelQoaptAy1HYtTkQLrmm/view"
                              target="_blank">1.3.2</a>
                          </li>
                          <li>
                            <a href="https://drive.google.com/file/d/1PMdSYPV7Qvgk4kUrrnBFRAuZ-A-OAMCm/view"
                              target="_blank">1.3.3</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion accordian-class table--1" id="criteria_1">
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria1-2" data-bs-toggle="collapse"
                      data-bs-target="#criteria1-2-1" aria-expanded="true" aria-controls="criteria1-2-1">
                      1.2
                    </h2>
                    <div id="criteria1-2-1" class="accordion-collapse collapse" aria-labelledby="criteria1-2"
                      data-bs-parent="#criteria_1">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li>
                            <a href="https://drive.google.com/file/d/1dlu2cDGcRkP0Dmd0xTtcpzZNdtr3NJF9/view"
                              target="_blank">1.2.1</a>
                          </li>
                          <li>
                            <a href="https://drive.google.com/file/d/10kQck3dt6wxCjy6ToDEzZ6lpT3XYHVG6/view"
                              target="_blank">1.2.2</a>
                          </li>
                          <li>
                            <a href="https://drive.google.com/file/d/17MwD53qzw72FeD2dVNrdFek2iQ2BjksE/view"
                              target="_blank">1.2.3</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria1-4" data-bs-toggle="collapse"
                      data-bs-target="#criteria1-4-2" aria-expanded="true" aria-controls="collapseOne">
                      1.4
                    </h2>
                    <div id="criteria1-4-2" class="accordion-collapse collapse" aria-labelledby="criteria1-4"
                      data-bs-parent="#criteria_1">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li>
                            <a href="https://drive.google.com/file/d/1hpsCV3moRmRp0pNKl6eZQRXqbRBXJXE9/view"
                              target="_blank">1.4.1</a>
                          </li>
                          <li>
                            <a href="https://drive.google.com/file/d/1SsdoPA3EA6wZQDEm7TqPsh6ics9GEXPq/view"
                              target="_blank">1.4.2</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- criteria 2 -->
            <div class="tab-pane fade" id="v-pills-Criteria2" role="tabpanel" aria-labelledby="v-pills-Criteria2-tab">
              <h3 class="yellow-color">Criteria 2</h3>
              <div class="row row-cols-2 justify-content-start align-items-top mt-3">
                <div class="accordion accordian-class table--1" id="criteria2">
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria2-1" data-bs-toggle="collapse"
                      data-bs-target="#criteria2-1-2" aria-expanded="true" aria-controls="collapseOne">
                      2.1
                    </h2>
                    <div id="criteria2-1-2" class="accordion-collapse collapse show" aria-labelledby="criteria2-1"
                      data-bs-parent="#criteria2">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li>
                            <a href="https://drive.google.com/file/d/1m4S08ePZEghQlUFfnguJDeXLiVOpuLjS/view"
                              target="_blank">2.1.2</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria2-3" data-bs-toggle="collapse"
                      data-bs-target="#criteria2-3-1" aria-expanded="true" aria-controls="collapseOne">
                      2.3
                    </h2>
                    <div id="criteria2-3-1" class="accordion-collapse collapse" aria-labelledby="criteria2-3"
                      data-bs-parent="#criteria2">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li>
                            <a href="https://drive.google.com/file/d/1Fzbn2IXtyNsoTe53JFkOMB-iBgdZpQYE/view"
                              target="_blank">2.3.1</a>
                          </li>
                          <li>
                            <a href="https://drive.google.com/file/d/1U4j36cUgM7bycqYLQlJ9MsNk-lb_11UW/view"
                              target="_blank">2.3.3</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria2-5" data-bs-toggle="collapse"
                      data-bs-target="#criteria2-5-2" aria-expanded="true" aria-controls="collapseOne">
                      2.5
                    </h2>
                    <div id="criteria2-5-2" class="accordion-collapse collapse" aria-labelledby="criteria2-5"
                      data-bs-parent="#criteria2">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li>
                            <a href="https://drive.google.com/file/d/1o5Tg7rh90PAE0A4QIqR7xMN6VAADzD8L/view"
                              target="_blank">2.5.1</a>
                          </li>
                          <li>
                            <a href="https://drive.google.com/file/d/1bWC3uK5A6UfOASAjoWo4g8jakYn0ppG4/view"
                              target="_blank">2.5.2</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion accordian-class table--1" id="criteria_2">
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria2-2" data-bs-toggle="collapse"
                      data-bs-target="#criteria2-2-2" aria-expanded="true" aria-controls="collapseOne">
                      2.2
                    </h2>
                    <div id="criteria2-2-2" class="accordion-collapse collapse" aria-labelledby="criteria2-2"
                      data-bs-parent="#criteria_2">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/2.2.1.pdf"
                              target="_blank">2.2.1</a>
                          </li>
                          <li>
                            <a href="https://drive.google.com/file/d/1G7oq8Ea25FO78MZwGPQmWGwg24SXkRh5/view"
                              target="_blank">2.2.2</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria2-4" data-bs-toggle="collapse"
                      data-bs-target="#criteria2-4-1" aria-expanded="true" aria-controls="collapseOne">
                      2.4
                    </h2>
                    <div id="criteria2-4-1" class="accordion-collapse collapse" aria-labelledby="criteria2-4"
                      data-bs-parent="#criteria_2">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li>
                            <a href="https://drive.google.com/file/d/1Kn0pU-bTKTJJM73uD5uX7e5dMcr4VXhU/view"
                              target="_blank">2.4.1</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria2-6" data-bs-toggle="collapse"
                      data-bs-target="#criteria2-6-2" aria-expanded="true" aria-controls="collapseOne">
                      2.6
                    </h2>
                    <div id="criteria2-6-2" class="accordion-collapse collapse" aria-labelledby="criteria2-6"
                      data-bs-parent="#criteria_2">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li>
                            <a href="https://drive.google.com/file/d/1OSTdGu7XfzQCgERzkMrdovRSd_yFC9Xr/view"
                              target="_blank">2.6.1</a>
                          </li>
                          <li>
                            <a href="https://drive.google.com/file/d/1exu8TsgMUH-Y8eZKmDEsE8AogCMAo8Cg/view"
                              target="_blank">2.6.2</a>
                          </li>
                          <li>
                            <a href="https://drive.google.com/file/d/1rLhqbFBFC8JhH5EY0nRpWoj7G-P3XQmJ/view"
                              target="_blank">2.6.3</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria2-7" data-bs-toggle="collapse"
                      data-bs-target="#criteria2-7-1" aria-expanded="true" aria-controls="collapseOne">
                      2.7
                    </h2>
                    <div id="criteria2-7-1" class="accordion-collapse collapse" aria-labelledby="criteria2-7"
                      data-bs-parent="#criteria_2">
                      <div class="accordion-body">
                        <ul class="list-before main-list">
                          <li>
                            <h6>2.7.1</h6>
                            <ul class="sublist">
                              <li>
                                <a href="https://drive.google.com/file/d/1my-EZsHer2lqEADPZXi-mojZGaYwYaUO/view"
                                  target="_blank">2.7.1</a>
                              </li>
                              <li>
                                <a href="https://docs.google.com/spreadsheets/d/1mVpaFp7FeUb24QtKhFWnwamjgPWp45Wq/edit?usp=sharing&ouid=109589624472401135606&rtpof=true&sd=true"
                                  target="_blank">2.7.1 Template</a>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- criteria 3 -->
            <div class="tab-pane fade" id="v-pills-Criteria3" role="tabpanel" aria-labelledby="v-pills-Criteria3-tab">
              <h3 class="yellow-color">Criteria 3</h3>
              <div class="row row-cols-2 justify-content-start align-items-top mt-3">
                <div class="accordion accordian-class table--1" id="criteria3">
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria3-1" data-bs-toggle="collapse"
                      data-bs-target="#criteria3-1-1" aria-expanded="true" aria-controls="collapseOne">
                      3.1
                    </h2>
                    <div id="criteria3-1-1" class="accordion-collapse collapse show" aria-labelledby="criteria3-1"
                      data-bs-parent="#criteria3">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li>
                            <a href="https://drive.google.com/file/d/1gz8nBDDJjc37ApMdtSI5AiKQGOhEWf6f/view"
                              target="_blank">3.1.3 Workshops, Seminars organised</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria3-3" data-bs-toggle="collapse"
                      data-bs-target="#criteria3-3-1" aria-expanded="true" aria-controls="collapseOne">
                      3.3
                    </h2>
                    <div id="criteria3-3-1" class="accordion-collapse collapse" aria-labelledby="criteria3-3"
                      data-bs-parent="#criteria3">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li>
                            <a href="https://drive.google.com/file/d/1HVW6aq5XVFVLyKcB9eqwb18hrfV-weBP/view"
                              target="_blank">3.3.1</a>
                          </li>
                          <li>
                            <a href="https://drive.google.com/file/d/1CND0MpMXP7L-007TGPhgteTPKX_iziC7/view"
                              target="_blank">3.3.3</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion accordian-class table--1" id="criteria_3">
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria3-4" data-bs-toggle="collapse"
                      data-bs-target="#criteria3-4-1" aria-expanded="true" aria-controls="collapseOne">
                      3.4
                    </h2>
                    <div id="criteria3-4-1" class="accordion-collapse collapse show" aria-labelledby="criteria3-4"
                      data-bs-parent="#criteria_3">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li>
                            <a href="https://drive.google.com/file/d/10bB8WV8J3ZbhsMiuCLYIm_w_CtUDgMHq/view"
                              target="_blank">3.4.1</a>
                          </li>
                          <li>
                            <a href="https://drive.google.com/file/d/1CcLQ4IDS8YPedfnJDYzJrvsxqRviWdQQ/view"
                              target="_blank">3.4.2</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- criteria 4 -->
            <div class="tab-pane fade" id="v-pills-Criteria4" role="tabpanel" aria-labelledby="v-pills-Criteria4-tab">
              <h3 class="yellow-color">Criteria 4</h3>
              <div class="row row-cols-2 justify-content-start align-items-top mt-3">
                <div class="accordion accordian-class table--1" id="criteria4">
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria4-1" data-bs-toggle="collapse"
                      data-bs-target="#criteria4-1-1" aria-expanded="true" aria-controls="collapseOne">
                      4.1
                    </h2>
                    <div id="criteria4-1-1" class="accordion-collapse collapse show" aria-labelledby="criteria4-1"
                      data-bs-parent="#criteria4">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li>
                            <a href="https://drive.google.com/file/d/1BjlhPD8v942JdVCezTY5RqIVDbv2qqfC/view"
                              target="_blank">4.1.1</a>
                          </li>
                          <li>
                            <a href="https://drive.google.com/file/d/1h7vKE7MozWgeW8wAfMBCZZYacjonOSfQ/view"
                              target="_blank">4.1.2</a>
                          </li>
                          <li>
                            <a href="https://drive.google.com/file/d/1MAJhxbmmx17MWGfMxjNoDnwWt7krUXrx/view"
                              target="_blank">4.1.3</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria4-3" data-bs-toggle="collapse"
                      data-bs-target="#criteria4-3-1" aria-expanded="true" aria-controls="collapseOne">
                      4.3
                    </h2>
                    <div id="criteria4-3-1" class="accordion-collapse collapse" aria-labelledby="criteria4-3"
                      data-bs-parent="#criteria4">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li>
                            <a href="https://drive.google.com/file/d/1Do6HsDo_U4q3ztCsG1B0JAZe1U5ANV3b/view"
                              target="_blank">4.3.3</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion accordian-class table--1" id="criteria_4">
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria4-2" data-bs-toggle="collapse"
                      data-bs-target="#criteria4-2-1" aria-expanded="true" aria-controls="collapseOne">
                      4.2
                    </h2>
                    <div id="criteria4-2-1" class="accordion-collapse collapse" aria-labelledby="criteria4-2"
                      data-bs-parent="#criteria_4">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li>
                            <a href="https://drive.google.com/file/d/1MTo5QtfKlK6o78quVD0J6ONBCjfkh2wn/view"
                              target="_blank">4.2.1</a>
                          </li>
                          <li>
                            <a href="https://drive.google.com/file/d/1pLUG5SL3FceAcigxiEXUejOCFlu3D1Bv/view"
                              target="_blank">4.2.4</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- criteria 5 -->
            <div class="tab-pane fade" id="v-pills-Criteria5" role="tabpanel" aria-labelledby="v-pills-Criteria5-tab">
              <h3 class="yellow-color">Criteria 5</h3>
              <div class="row row-cols-2 justify-content-start align-items-top mt-3">
                <div class="accordion accordian-class table--1" id="criteria5">
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria5-1" data-bs-toggle="collapse"
                      data-bs-target="#criteria5-1-1" aria-expanded="true" aria-controls="collapseOne">
                      5.1
                    </h2>
                    <div id="criteria5-1-1" class="accordion-collapse collapse show" aria-labelledby="criteria5-1"
                      data-bs-parent="#criteria5">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li>
                            <a href="https://drive.google.com/file/d/1ZPHvDaLJhx_EB-1ZKcNjTgseFFr1tv_k/view"
                              target="_blank">5.1.1</a>
                          </li>
                          <li>
                            <a href="https://drive.google.com/file/d/1J6yahGRg4i_yo5xz7yAtEfg0RMnJJ5rO/view"
                              target="_blank">5.1.3</a>
                          </li>
                          <li>
                            <a href="https://drive.google.com/file/d/1Izzgqq8JL3rV7c1ZszUcpQWViPE47zka/view"
                              target="_blank">5.1.4</a>
                          </li>
                          <li>
                            <a href="https://drive.google.com/file/d/1wdbKzb-DSjDBfzY78IHt9-Q6kZNh_5Fb/view"
                              target="_blank">5.1.5</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria5-3" data-bs-toggle="collapse"
                      data-bs-target="#criteria5-3-1" aria-expanded="true" aria-controls="collapseOne">
                      5.3
                    </h2>
                    <div id="criteria5-3-1" class="accordion-collapse collapse" aria-labelledby="criteria5-3"
                      data-bs-parent="#criteria5">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li>
                            <a href="https://drive.google.com/file/d/1Xdq32T2u-w6ApCrAorp7eVFpKmgQlxvN/view"
                              target="_blank">5.3.1</a>
                          </li>
                          <li>
                            <a href="https://drive.google.com/file/d/1PWmWNdRlDiN0MYnthzkBZVulP5q4B0ij/view"
                              target="_blank">5.3.2</a>
                          </li>
                          <li>
                            <a href="https://drive.google.com/file/d/19JyGh5v8rORThphGGsBrEWK6HVvXRFST/view"
                              target="_blank">5.3.3</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion accordian-class table--1" id="criteria_5">
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria5-2" data-bs-toggle="collapse"
                      data-bs-target="#criteria5-2-2" aria-expanded="true" aria-controls="collapseOne">
                      5.2
                    </h2>
                    <div id="criteria5-2-2" class="accordion-collapse collapse" aria-labelledby="criteria5-2"
                      data-bs-parent="#criteria_5">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li>
                            <a href="https://drive.google.com/file/d/1IVmX0gQ4WTfcg-wzFD8wMYeG6WYRnum0/view"
                              target="_blank">5.2.1</a>
                          </li>
                          <li>
                            <a href="https://drive.google.com/file/d/1oFrpKKWWFlF7Lc1ClscpSDhy6xpa1cA7/view"
                              target="_blank">5.2.2</a>
                          </li>
                          <li>
                            <a href="https://drive.google.com/file/d/1IciwNMjEQwAa41pTvTMpyRmTksQZoj-u/view"
                              target="_blank">5.2.3</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria5-4" data-bs-toggle="collapse"
                      data-bs-target="#criteria5-4-1" aria-expanded="true" aria-controls="collapseOne">
                      5.4
                    </h2>
                    <div id="criteria5-4-1" class="accordion-collapse collapse" aria-labelledby="criteria5-4"
                      data-bs-parent="#criteria_5">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li>
                            <a href="https://drive.google.com/file/d/109UHhAE1GsqySYWcM1Wj7tQHikTY5YEf/view"
                              target="_blank">5.4.1</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- criteria 6 -->
            <div class="tab-pane fade" id="v-pills-Criteria6" role="tabpanel" aria-labelledby="v-pills-Criteria6-tab">
              <h3 class="yellow-color">Criteria 6</h3>
              <div class="row row-cols-2 justify-content-start align-items-top mt-3">
                <div class="accordion accordian-class table--1" id="criteria6">
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria6-1" data-bs-toggle="collapse"
                      data-bs-target="#criteria6-1-1" aria-expanded="true" aria-controls="collapseOne">
                      6.1
                    </h2>
                    <div id="criteria6-1-1" class="accordion-collapse collapse show" aria-labelledby="criteria6-1"
                      data-bs-parent="#criteria6">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li>
                            <a href="https://drive.google.com/file/d/1yJlDJoK3nv0uR6X0SLmtunH0CFYWhT_R/view"
                              target="_blank">6.1.1</a>
                          </li>
                          <li>
                            <a href="https://drive.google.com/file/d/1GyqqvwKpqyOy31o2J51wxyzudE2VQ5aN/view"
                              target="_blank">6.1.2</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria6-3" data-bs-toggle="collapse"
                      data-bs-target="#criteria6-3-1" aria-expanded="true" aria-controls="collapseOne">
                      6.3
                    </h2>
                    <div id="criteria6-3-1" class="accordion-collapse collapse" aria-labelledby="criteria6-3"
                      data-bs-parent="#criteria6">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li>
                            <a href="https://drive.google.com/file/d/1wh7-uhLYQq1ZcoBwKf-YrswqzO0NTv-R/view"
                              target="_blank">6.3.1</a>
                          </li>
                          <li>
                            <a href="https://drive.google.com/file/d/1VshJcxnB9q3WutBLUs2B67-KxUNPesdj/view"
                              target="_blank">6.3.2</a>
                          </li>
                          <li>
                            <a href="https://drive.google.com/file/d/1zac8_3PF2lrL3zElI-6V1bg56vIhup9o/view"
                              target="_blank">6.3.3</a>
                          </li>
                          <li>
                            <a href="https://drive.google.com/file/d/1FQtOAicwnlfQ24bkPpj6i0mXbeA2aGn4/view"
                              target="_blank">6.3.4</a>
                          </li>
                          <li>
                            <a href="https://drive.google.com/file/d/1mFmVe_wYIyKlxviRKtrV9Lk4UXzyvj5o/view"
                              target="_blank">6.3.5</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria6-5" data-bs-toggle="collapse"
                      data-bs-target="#criteria6-5-1" aria-expanded="true" aria-controls="collapseOne">
                      6.5
                    </h2>
                    <div id="criteria6-5-1" class="accordion-collapse collapse" aria-labelledby="criteria6-5"
                      data-bs-parent="#criteria6">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li>
                            <a href="https://drive.google.com/file/d/1wj1OGRnh0_GX-q-eB_R4jjXwsLW_PZvT/view"
                              target="_blank">6.5.1</a>
                          </li>
                          <li>
                            <a href="https://drive.google.com/file/d/1MwCa6F66q8sCVqklaq-dF2IL9NOaOjzt/view"
                              target="_blank">6.5.2</a>
                          </li>
                          <li>
                            <a href="https://drive.google.com/file/d/1ZGwbWjXrqEzr2qPMwVjpxCnOpx1ndEbR/view"
                              target="_blank">6.5.3</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion accordian-class table--1" id="criteria_6">
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria6-2" data-bs-toggle="collapse"
                      data-bs-target="#criteria6-2-3" aria-expanded="true" aria-controls="collapseOne">
                      6.2
                    </h2>
                    <div id="criteria6-2-3" class="accordion-collapse collapse" aria-labelledby="criteria6-2"
                      data-bs-parent="#criteria_6">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li>
                            <a href="https://drive.google.com/file/d/1nMvRWBoPbswpLX8uKgws3viLOXCZBy-q/view"
                              target="_blank">6.2.1</a>
                          </li>
                          <li>
                            <a href="https://drive.google.com/file/d/1inXS10sUPHJGwO4S-mDgkarmI6K39I8L/view"
                              target="_blank">6.2.2</a>
                          </li>
                          <li>
                            <a href="https://drive.google.com/file/d/1wkTdt8PHKFBtEPdePFCsj20NxYaOcHJX/view"
                              target="_blank">6.2.3</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria6-4" data-bs-toggle="collapse"
                      data-bs-target="#criteria6-4-1" aria-expanded="true" aria-controls="collapseOne">
                      6.4
                    </h2>
                    <div id="criteria6-4-1" class="accordion-collapse collapse" aria-labelledby="criteria6-4"
                      data-bs-parent="#criteria_6">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li>
                            <a href="https://drive.google.com/file/d/18iOKmSni4kXTQFWJ236mN9nmE-DnfMJk/view"
                              target="_blank">6.4.1</a>
                          </li>
                          <li>
                            <a href="https://drive.google.com/file/d/1tF38D1i6L31geEcLGzePoH89jJTQNTrO/view"
                              target="_blank">6.4.3</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- criteria 7 -->
            <div class="tab-pane fade" id="v-pills-Criteria7" role="tabpanel" aria-labelledby="v-pills-Criteria7-tab">
              <h3 class="yellow-color">Criteria 7</h3>
              <div class="row row-cols-2 justify-content-start align-items-top mt-3">
                <div class="accordion accordian-class table--1" id="criteria7">
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria7-1" data-bs-toggle="collapse"
                      data-bs-target="#criteria7-1-2" aria-expanded="true" aria-controls="collapseOne">
                      7.1
                    </h2>
                    <div id="criteria7-1-2" class="accordion-collapse collapse" aria-labelledby="criteria7-1"
                      data-bs-parent="#criteria7">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li>
                            <a href="https://drive.google.com/file/d/1F8RsHjb3pmgSdDfvotKTnPzjSdH-0jt0/view"
                              target="_blank">7.1.1 Measures Initiated by the Institution</a>
                          </li>
                          <li>
                            <a href="https://drive.google.com/file/d/1xlfi_MrPc-durlclM2POUy3pabRBb5Lg/view"
                              target="_blank">7.1.2 Facilities for Alternate Sources of Energy</a>
                          </li>
                          <li>
                            <a href="https://drive.google.com/file/d/19xZcD-GdUWev6GPhtEKI3Adk1828FD7L/view"
                              target="_blank">7.1.3 Facilities for managment of Degradable & Non Degardble waste</a>
                          </li>
                          <li>
                            <a href="https://drive.google.com/file/d/1GnHdnol4OFfzSBQoScP2kS8OnwHTSUyP/view"
                              target="_blank">7.1.4 Water Conservation Facilities</a>
                          </li>
                          <li>
                            <a href="https://drive.google.com/file/d/1WqWy7CTF5A8XNjGbmaLv2XMHzwPAGjXt/view"
                              target="_blank">7.1.5 Green Campus Initiatives</a>
                          </li>
                          <li>
                            <a href="https://drive.google.com/file/d/1G1eel3hKPKnTWgeHybGsVmxch6g8o7fh/view"
                              target="_blank">7.1.6 Environment & Energy Initiatives</a>
                          </li>
                          <li>
                            <a href="https://drive.google.com/file/d/1uMDvq_V9su4-dsgDedOw8UHr9s5qaVpx/view"
                              target="_blank">7.1.7 Disabled Friendly Barrier Free Environment</a>
                          </li>
                          <li>
                            <a href="https://drive.google.com/file/d/1fu0QP1JOJBJwKceLU_JlF08gRBcBSN8X/view"
                              target="_blank">7.1.8 Institutional Efforts Initiative</a>
                          </li>
                          <li>
                            <a href="https://drive.google.com/file/d/1IoJJs8Y3OVfSvmbjNqa-2uhZiu10fSWF/view"
                              target="_blank">7.1.9 Sensitization of Students & Employees</a>
                          </li>
                          <li>
                            <a href="https://drive.google.com/file/d/1l0HmuHo-A7BXyqApN8JY8WEZD7TcXNz7/view"
                              target="_blank">7.1.10 Code of Conduct</a>
                          </li>
                          <li>
                            <a href="https://drive.google.com/file/d/1p9tG5KHTsodFxei2RqscSjQumYgM8SLM/view"
                              target="_blank">7.1.11 Institute Celebrate Days, Events, Festivals</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria7-3" data-bs-toggle="collapse"
                      data-bs-target="#criteria7-3-1" aria-expanded="true" aria-controls="collapseOne">
                      7.3
                    </h2>
                    <div id="criteria7-3-1" class="accordion-collapse collapse" aria-labelledby="criteria7-3"
                      data-bs-parent="#criteria7">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li>
                            <a href="https://drive.google.com/file/d/1AmrZWZDLhjf75qeG4Kk5g4splX3n1-4R/view"
                              target="_blank">7.3.1 Portray the Performance of the Institution</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion accordian-class table--1" id="criteria_7">
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria7-2" data-bs-toggle="collapse"
                      data-bs-target="#criteria7-2-1" aria-expanded="true" aria-controls="collapseOne">
                      7.2
                    </h2>
                    <div id="criteria7-2-1" class="accordion-collapse collapse" aria-labelledby="criteria7-2"
                      data-bs-parent="#criteria_7">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li>
                            <a href="https://drive.google.com/file/d/1q155YSKhvnWqkmjPE5HGbSELF5EJtrbs/view"
                              target="_blank">7.2.1 Best Practice</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- extended template -->
            <div class="tab-pane fade" id="v-pills-template" role="tabpanel" aria-labelledby="v-pills-template-tab">
              <h3 class="yellow-color">Extended Template</h3>
              <div class="row row-cols-1 justify-content-start align-items-top mt-3">
                <div class="accordion accordian-class table--1" id="template">
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="extended" data-bs-toggle="collapse"
                      data-bs-target="#extended_template" aria-expanded="true" aria-controls="collapseOne">
                      Extended Template
                    </h2>
                    <div id="extended_template" class="accordion-collapse collapse" aria-labelledby="extended"
                      data-bs-parent="#template">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li>
                            <a href="https://drive.google.com/file/d/1XVmcYbbiZNcLKckWS3RRhS7OgDKFq5P1/view"
                              target="_blank">3.2</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
